import { LoadingOutlined } from "@ant-design/icons";
import { Box } from "@mui/material";

export default function WrapperLoading() {
  return (
    <Box
      marginTop={10}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <LoadingOutlined style={{ fontSize: 35 }} />
    </Box>
  );
}
